import { useStorage } from '@vueuse/core';

function safeUUID() {
    if (
        typeof crypto !== 'undefined' &&
        typeof crypto.randomUUID === 'function'
    ) {
        return crypto.randomUUID();
    }

    // Fallback for environments that don’t support it
    const hex = Array.from(crypto.getRandomValues(new Uint8Array(16)));
    hex[6] = (hex[6] & 0x0f) | 0x40;
    hex[8] = (hex[8] & 0x3f) | 0x80;

    return [...hex.entries()]
        .map(([i, b]) => {
            const s = b.toString(16).padStart(2, '0');
            return [4, 6, 8, 10].includes(i) ? `-${s}` : s;
        })
        .join('');
}

export const useAnonId = () => {
    const anonIdKey = 'anon_id';

    const anonId = import.meta.client
        ? useStorage<string | null>(anonIdKey, null)
        : ref(null);

    const getOrCreateAnonId = (): string | null => {
        if (!import.meta.client) return null;

        if (!anonId.value) {
            anonId.value = safeUUID();
        }

        return anonId.value;
    };

    const destroyAnonId = () => {
        if (!import.meta.client) return;

        anonId.value = null;
    };

    return {
        getOrCreateAnonId,
        destroyAnonId,
    };
};
